import {
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { ShippingMethod } from '../../interfaces/Shipping/ShippingMethod';
import { formatCurrency } from '../../utils/Currency';

type SelectShippingProps = {
  shippingMethods: ShippingMethod[];
  selectedShippingMethod: number;
  onShippingMethodChange: (id: number) => void;
  isFreeShipping: boolean;
};

export const SelectShipping = ({
  shippingMethods,
  selectedShippingMethod,
  onShippingMethodChange,
  isFreeShipping,
}: SelectShippingProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        px: 2.5,
        py: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
    >
      <Typography sx={{ fontWeight: 600 }}>Teslimat Seçenekleri</Typography>

      <RadioGroup
        value={selectedShippingMethod}
        onChange={(e) => onShippingMethodChange(Number(e.target.value))}
      >
        {shippingMethods.map((x) => (
          <FormControlLabel
            key={x.id}
            value={x.id}
            control={<Radio />}
            label={`${x.name} + ${formatCurrency(
              isFreeShipping ? x.discountedPrice : x.price,
            )}`}
          />
        ))}
      </RadioGroup>
    </Paper>
  );
};
